import { render, staticRenderFns } from "./BottleAdd.vue?vue&type=template&id=66046556&scoped=true&"
import script from "./BottleAdd.vue?vue&type=script&lang=js&"
export * from "./BottleAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66046556",
  null
  
)

export default component.exports